import { render, staticRenderFns } from "./goods-type-detail.vue?vue&type=template&id=501c8297&scoped=true&"
import script from "./goods-type-detail.vue?vue&type=script&lang=js&"
export * from "./goods-type-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501c8297",
  null
  
)

export default component.exports